import styled from 'styled-components';

export const ListScrollOverlayIndicator = styled.div<{ $showBottomShadow: boolean }>`
  flex: 1;
  overflow: auto;
  position: relative;

  &::after {
    background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #fff 87.97%);
    border-radius: 0 0 12px 12px;
    bottom: 0;
    content: '';
    display: block;
    height: 43px;
    opacity: 0;
    pointer-events: none;
    position: absolute;
    width: 100%;

    ${({ $showBottomShadow }) => $showBottomShadow && 'opacity: 1'};
  }
`;
